import React from 'react';
import {
  InputGroup,
  UncontrolledButtonDropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle
} from 'reactstrap';
import { reduxForm } from 'redux-form';
import { LinkContainer } from 'react-router-bootstrap';
import URI from 'urijs';

// containers
import RealtorSearch from './Search/RealtorSearch';
import ServiceProviderSearch from './Search/ServiceProviderSearch';

// components
import { MEMBER_TYPE_MAP } from '../../ducks/AgentSearch';

// modules
import BS from '../../theme/Bootstrap';

let SearchForm = props => {
  const { initialValues } = props;
  const memberType = initialValues.memberType || 'realtor';

  return renderMemberTypeForm({
    memberType,
    ...props
  });
};

const renderMemberTypeForm = props => {
  const { memberType } = props;

  switch (memberType) {
    case 'realtor':
    default:
      return <RealtorSearch {...props}>{renderProviderDropdown(props)}</RealtorSearch>;
    case 'service_provider':
      return (
        <ServiceProviderSearch {...props}>
          {renderProviderDropdown(props)}
        </ServiceProviderSearch>
      );
  }
};

const renderProviderDropdown = ({ memberType }) => (
  <InputGroup className={`${BS.inputGroupGutter} ${BS.pb2}`}>
    <UncontrolledButtonDropdown>
      <DropdownToggle color="dark-blue" outline caret>
        {MEMBER_TYPE_MAP[memberType].label}
      </DropdownToggle>
      <DropdownMenu>
        {Object.keys(MEMBER_TYPE_MAP).map((key, i) => (
          <LinkContainer
            to={URI(MEMBER_TYPE_MAP[key].url).toString()}
            isActive={() => memberType === key}
            key={i}
          >
            <DropdownItem>{MEMBER_TYPE_MAP[key].label}</DropdownItem>
          </LinkContainer>
        ))}
      </DropdownMenu>
    </UncontrolledButtonDropdown>
    <span className={`${BS.ml2} ${BS.mr3}`}>|</span>
  </InputGroup>
);

const AgentSearchForm = reduxForm({
  form: 'agent-search-form'
})(SearchForm);

export default AgentSearchForm;



// WEBPACK FOOTER //
// ./src/containers/AgentSearch/AgentSearchForm.js